import React, { useContext } from 'react';
import * as yup from 'yup';
import { gridSpacing } from '../../../../common/themes/constants';
import {
  Grid,
} from '@mui/material';
import { HookFormTextField } from '../../../common/components';
import OrganizationOptions from '../../../auth/RegisterUser/OrganizationOptions';
import GroupOptions from '../../../auth/RegisterUser/GroupOptions';
import MobileNumberMask from '../../../common/components/mask/MobileNumberMask';
import AuthContext from '../../../auth/context/AuthContext';
import User from '../../../auth/models/User';
import AddressAutocomplete from '../../../common/components/address/AddressAutoComplete';
import ClinicTagsHookFormAutocomplete from '../../components/ClinicTagsHookFormAutocomplete';
import ClinicTimeFormatToggleField from '../../components/ClinicTimeFormatToggleField';
import {
  CLINIC_TIME_FORMAT_OPTIONS,
  DEFAULT_CLINIC_TIME_FORMAT,
} from '../../../common/services/ClinicTimeFormatUtils';

export const initialValues = {
  name: '',
  code: '',
  referral_network: '',
  organization: '',
  office_phone: '',
  fax: '',
  full_address: '',
  is_order: false,
  time_format: DEFAULT_CLINIC_TIME_FORMAT,
  tags: [],
};

export const createClinicValidationSchema = yup.object().shape({
  name: yup.string().required('Clinic name is required'),
  code: yup.string(),
  referral_network: yup.string().nullable(),
  organization: yup.string().nullable(),
  office_phone: yup
    .string()
    .matches(/.{12,}/, {
      excludeEmptyString: true,
      message: 'Office phone number must have 10 digits',
    }),
  fax: yup
    .string()
    .matches(/.{12,}/, {
      excludeEmptyString: true,
      message: 'Fax must have 10 digits',
    }),
  address_line1: yup.string().required('Address Line 1 is required'),
  address_city: yup.string().required('City is required'),
  address_state: yup.string().required('State is required'),
  address_zip: yup.string().length(5, 'Zip code must have 5 digits').required('Zipcode is required'),
  is_order: yup.boolean().required(),
  time_format: yup.string().oneOf(['', ...CLINIC_TIME_FORMAT_OPTIONS.map(option => option.value)]),
  tags: yup.array().of(yup.string()),
});

export default function CreateClinicForm({ control, errors, prefix = null, handleRetrieve }) {
  const currentUser = new User(useContext(AuthContext));
  const showExtraFields = currentUser.isAdmin();

  return (
    <Grid container spacing={gridSpacing}>
      <Grid item
        sm={8}
        xs={12}>
        <HookFormTextField
          id="name"
          name="name"
          placeholder="Enter clinic name"
          label="Clinic name *"
          schema="name"
          prefix={prefix}
          control={control}
          errors={errors}
          autoFocus
          fullWidth
        />
      </Grid>

      {showExtraFields && (
        <>
          <Grid item sm={4} xs={12}>
            <HookFormTextField
              id="code"
              name="code"
              placeholder="Enter clinic code"
              label="Clinic code"
              schema="code"
              prefix={prefix}
              control={control}
              errors={errors}
              fullWidth
            />
          </Grid>
          <Grid item sm={12} xs={12}>
            <GroupOptions
              schema="referral_network"
              placeholder="Enter the Referral Group"
              label="Referral Group"
              prefix={prefix}
              control={control}
              errors={errors}
            />
          </Grid>
          <Grid item sm={12} xs={12}>
            <OrganizationOptions
              schema="organization"
              placeholder="Enter the organization"
              label="Organization"
              prefix={prefix}
              control={control}
              errors={errors}
            />
          </Grid>
        </>
      )}


      <Grid item sm={6} xs={12}>
        <HookFormTextField
          id="office_phone"
          name="office_phone"
          type="tel"
          placeholder="Enter Office Phone"
          label="Office Phone"
          autoComplete="office_phone"
          schema="office_phone"
          prefix={prefix}
          control={control}
          errors={errors}
          InputProps={{
            inputComponent: MobileNumberMask,
          }}
          fullWidth
        />
      </Grid>
      <Grid item sm={6} xs={12}>
        <HookFormTextField
          id="fax"
          name="fax"
          type="tel"
          placeholder="Enter Fax number"
          label="Fax number"
          autoComplete="fax"
          schema="fax"
          prefix={prefix}
          control={control}
          errors={errors}
          InputProps={{
            inputComponent: MobileNumberMask,
          }}
          fullWidth
        />
      </Grid>
      <Grid item
        sm={12}
        xs={12}>

        <AddressAutocomplete
          control={control}
          name={'full_address'}
          errors={errors}
          prefix={prefix}
          placeholder={'Enter Address'}
          handleRetrieve={handleRetrieve}
          label={'Address*'}
        />
      </Grid>

      <Grid item xs={12} md={12}>
        <ClinicTimeFormatToggleField
          schema="time_format"
          prefix={prefix}
          control={control}
          errors={errors}
        />
      </Grid>

        <Grid item xs={12} md={12}>
            <ClinicTagsHookFormAutocomplete
                schema="tags"
                prefix={prefix}
                control={control}
                errors={errors}
                existingTags={[]}
                fullWidth
            />
        </Grid>
    </Grid>
  );
}
